(function ($) {
  'use strict';

  $(document).ready(function () {
    // Assuming your form has a class named 'my-popup-form'
    $('.webform-submission-subscribe-action-form').on('submit', function () {
      // modal class to hide
      $('.block-newslettersignupblock-modal').hide();

      // Set a cookie to remember that the popup should be hidden
      // eslint-disable-next-line no-use-before-define
      createCookie('popup_hidden', '1', 30);
    });

    // Check the cookie on page load and hide the popup if the cookie is set
    // eslint-disable-next-line no-use-before-define
    if (readCookie('popup_hidden') === '1') {
      $('.block-newslettersignupblock-modal').hide();
    }

    // Add click event for "No thanks" link
    $('#edit-processed-text a').on('click', function (e) {
      e.preventDefault(); // Prevent the link from navigating to the href
      // Replace 'modal_class' with the actual class of your popup
      $('.block-newslettersignupblock-modal').hide();

      // Set a cookie to remember that the popup should be hidden
      // eslint-disable-next-line no-use-before-define
      createCookie('popup_hidden', '1', 30);
    });
  });

  // Creating cookie
  function createCookie(name, value, days) {
    if (days > 0) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      var expires = '; expires=' + date.toGMTString();
    } else {
      var expires = '';
    }
    document.cookie = name + '=' + value + expires + '; path=/';
  }

  // Reading cookie
  function readCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }

})(jQuery);

// Accessibility fix: add a visually-hidden label for the g-recaptcha-response
// textarea that Google's reCAPTCHA v2 script injects asynchronously.
// The standard reCAPTCHA widget does not provide a label, which fails
// WCAG 2.1 SC 1.3.1 and 4.1.2. A MutationObserver is used because the
// textarea is injected after drupalRecaptchaOnload fires, outside of the
// normal Drupal behaviors lifecycle.
// See: https://www.drupal.org/project/recaptcha/issues/3497036
Drupal.behaviors.recaptchaA11yLabel = {
  attach: function (context) {
    // Only set up the observer once, from the full-document context.
    if (context !== document) {
      return;
    }

    function addLabel(textarea) {
      if (textarea.tagName !== 'TEXTAREA') {
        return;
      }
      var labelId = textarea.id || 'g-recaptcha-response';
      // Avoid adding a duplicate label.
      if (document.querySelector('label[for="' + labelId + '"]')) {
        return;
      }
      var label = document.createElement('label');
      label.setAttribute('for', labelId);
      label.className = 'visually-hidden';
      label.textContent = Drupal.t('reCAPTCHA');
      textarea.parentNode.insertBefore(label, textarea);
    }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var addedNodes = mutations[i].addedNodes;
        for (var j = 0; j < addedNodes.length; j++) {
          var node = addedNodes[j];
          if (node.nodeType !== 1) {
            continue;
          }
          if (node.classList && node.classList.contains('g-recaptcha-response')) {
            addLabel(node);
          }
          var nested = node.getElementsByClassName('g-recaptcha-response');
          for (var k = 0; k < nested.length; k++) {
            addLabel(nested[k]);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
};
